import React, { useEffect, useState } from 'react';
import './assests/css/style.css';
import NewHeader from './components/NewHeader';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import imgurl from './assests/images/imgurl';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardActions';
import BotComponent from './BotComponent';
import AlertComp from './Alert';

import { useSelector, useDispatch } from 'react-redux'
import { setfname, setlname,setbday } from './Reducers/reducer';

function ProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [alertopen, setalertopen] = useState(false)
  const [alertmsg, setalertmsg] = useState('Please enter all details')
  const [firstname,setfirstname] = useState(null)
  const [lastname,setlastname] = useState(null)
  const [dob,setdob] = useState(null)
  const profile = useSelector((state) => state.user.profile)

  useEffect(()=>{
    const today = new Date();
    const year = today.getFullYear() - 18;
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const maxDate = `${year}-${month}-${day}`;
    document.getElementById('dob').setAttribute('max',maxDate)
  })

  function setFirstName(e){
    console.log(e.target.value);
    setfirstname(e.target.value)
  }

  function setLastName(e){
    console.log(e.target.value);
    setlastname(e.target.value)
  }

  function setDOB(e){
    console.log(e.target.value);
    setdob(e.target.value)
  }

  function checkValue(){
    if(dob && firstname && lastname){
      dispatch(setfname(firstname))
      dispatch(setlname(lastname))
      dispatch(setbday(dob))
      navigate('/questionnaire')
    }else{
      setalertopen(true)
      setTimeout(() => {
        setalertopen(false)
    }, 3000);
    }
  }

  return (
    <div className="profilepage">
      <NewHeader />

      <div className="blue-shape2"vvfvessfsv vfffdffdaff dadev avsvfafssfsfsds>
        <img src={imgurl.shape2} alt="Decorative Shape2" className="decorative-shapetwo" />
      </div>

      <Card className='profilecard'>
        <CardContent className='profilecontent'>
          <div className='profilebgimg'>
            <img src={imgurl.profilebg} alt="Profile Background" />
          </div>
          <Grid container spacing={3} className="profilefields">
            <Grid item xs={12}>
              <TextField id="firstname" label="First Name" variant="outlined" className="bluefield" onChange={(e)=>setFirstName(e)}/>
            </Grid>
            <Grid item xs={12}>
              <TextField id="lastname"  label="Last Name" variant="outlined" className="whitefield" onChange={(e)=>setLastName(e)}/>
            </Grid>
            {/* <Grid item xs={12}>
  <TextField id="emailadd" label="Email Address" variant="outlined" className="whitefield" />
  </Grid> */}
            <Grid item xs={12}>
              <TextField id="dob" type='date' label="Date of birth" variant="outlined" InputLabelProps={{
            shrink: true,
          }} className="whitefield" onChange={(e)=>setDOB(e)} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>



      <Grid className="btnssection">
        <Grid item xs={6}>
          {/* <div className="prevbtn">
      <Button variant="contained" onClick={()=>navigate('/otppage')}>
        <div className="prevbtntext"> 
        <img src={imgurl.backarrow} alt="Backward arrows"/>
          <p> Previous </p>
          </div>
      
        </Button>
      </div> */}
        </Grid>
        <Grid item xs={6}>
          <div className="nextbtn">
            <Button variant="contained" onClick={() =>checkValue()}>
              <div className="nextbtntext">
                <p> Next </p>
                <img src={imgurl.arrows} alt="Forward arrows" />
              </div>

            </Button>
          </div>
        </Grid>
      </Grid>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />

      <div className='shapeblue'>
        <img src={imgurl.shapeblue} alt="Blue shape" />
      </div>
    </div>
  );
}

export default ProfilePage;
